// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-content .acceptedBg {
  background: linear-gradient(13deg, var(--ion-ultra-success), var(--ion-pass-success));
  background-color: #fff;
}
.main-content .rejectedBg {
  background: linear-gradient(13deg, var(--ion-ultra-danger), var(--ion-pass-danger));
  background-color: #fff;
}
.main-content .rescheduledBg {
  background: linear-gradient(13deg, var(--ion-ultra-warning), var(--ion-pass-warning));
  background-color: #fff;
}
.main-content .completedBg {
  background: linear-gradient(13deg, var(--ion-ultra-info), var(--ion-pass-info));
  background-color: #fff;
}
.main-content .pendingBg {
  background: linear-gradient(13deg, var(--ion-ultra-secondary), var(--ion-pass-secondary));
  background-color: #fff;
}
.main-content .conCard {
  min-height: 25vw;
  display: flex;
  flex-direction: row;
  padding: 0vw;
  align-items: stretch;
  justify-content: space-between;
  border-radius: 15px;
}
.main-content .conCard .conImg {
  height: 25vw;
  min-width: 25vw;
  max-width: 25vw;
  object-fit: contain;
  border-radius: 13px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  padding: 1vw;
}
.main-content .conCard .conImg .conPic {
  height: 25vw;
  width: 100%;
  object-fit: cover;
  border-radius: 13px;
  position: relative;
  overflow: hidden;
  box-shadow: var(--shadow-l);
}
.main-content .conCard .conInfo {
  height: 25vw;
  width: calc(100% - 25vw);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0vw;
  position: relative;
}
.main-content .conCard .conInfo .conStatus {
  width: 23vw;
  height: 6vw;
  margin: 1vw;
  font-size: 10px;
  letter-spacing: 1px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  text-transform: uppercase;
  backdrop-filter: blur(5px);
  box-shadow: var(--shadow-m);
}
.main-content .conCard .conInfo .acceptedStatus {
  border: 1px solid var(--ion-color-success);
  color: var(--ion-text-success);
  text-shadow: 0em 0.15em 0.05em var(--ion-color-success);
  background: linear-gradient(13deg, var(--ion-more-success), var(--ion-clear-success));
}
.main-content .conCard .conInfo .rejectedStatus {
  border: 1px solid var(--ion-color-danger);
  color: var(--ion-text-danger);
  text-shadow: 0em 0.15em 0.05em var(--ion-color-danger);
  background: linear-gradient(13deg, var(--ion-more-danger), var(--ion-clear-danger));
}
.main-content .conCard .conInfo .rescheduledStatus {
  border: 1px solid var(--ion-color-warning);
  color: var(--ion-text-warning);
  text-shadow: 0em 0.15em 0.05em var(--ion-color-warning);
  background: linear-gradient(13deg, var(--ion-more-warning), var(--ion-clear-warning));
}
.main-content .conCard .conInfo .completedStatus {
  border: 1px solid var(--ion-color-info);
  color: var(--ion-text-info);
  text-shadow: 0em 0.15em 0.05em var(--ion-color-info);
  background: linear-gradient(13deg, var(--ion-more-info), var(--ion-clear-info));
}
.main-content .conCard .conInfo .pendingStatus {
  border: 1px solid var(--ion-color-secondary);
  color: var(--ion-text-secondary);
  text-shadow: 0em 0.15em 0.05em var(--ion-color-secondary);
  background: linear-gradient(13deg, var(--ion-more-secondary), var(--ion-clear-secondary));
}
.main-content .conCard .conInfo .conInner {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 2vw;
}
.main-content .conCard .conInfo .conInner .consultantName {
  font-size: 18px;
  letter-spacing: 1px;
  font-weight: 600;
}
.main-content .conCard .conInfo .conInner .consultantAbout {
  font-size: 12px;
}
.main-content .conCard .conInfo .conInner .conNotes {
  font-size: 14px;
  font-weight: 200;
}
.main-content .conCard .conInfo .conData {
  font-size: 14px;
  font-weight: 400;
  display: flex;
  flex-direction: row;
  min-height: 6vw;
  margin: 1vw;
  align-items: center;
  width: 100%;
  justify-content: space-evenly;
}
.main-content .conCard .conInfo .conData .conSlot {
  font-size: 12px;
  font-weight: 300;
  font-style: italic;
}

.mainCard {
  scale: 1;
  border-radius: 15px;
  box-shadow: var(--shadow-m);
  width: 94vw;
  height: 25vw;
  margin: 0 auto;
  margin-top: 4vw;
  padding: 0vw;
}

.reorder-list-active .reorder-selected {
  scale: 0.9;
  border-radius: 15px;
  box-shadow: var(--shadow-l);
}

.customFooter {
  bottom: 0;
  position: fixed;
  left: 0;
  height: calc(20vw + env(safe-area-inset-bottom));
  padding-bottom: env(safe-area-inset-bottom);
  width: 100vw;
  background: linear-gradient(0deg, var(--ion-color-primary) 0%, var(--ion-more-primary) 50%, hsl(var(--drop-pass-primary)/0) 100%);
  background-size: 200% 200%;
  background-position: 0 0%;
}
.customFooter .footerToolbar {
  background: transparent;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2vw;
}
.customFooter .footerToolbar .footerBtn {
  max-width: 75%;
  min-height: 6vh;
  height: 6vh;
}

.pageContainer {
  padding-top: calc(1vh + env(safe-area-inset-top));
  padding-bottom: calc(22vw + env(safe-area-inset-bottom));
}`, "",{"version":3,"sources":["webpack://./src/app/calendar/meal-preference/meal-preference.page.scss"],"names":[],"mappings":"AAGE;EAEE,qFAAA;EACA,sBAAA;AAHJ;AAME;EAEE,mFAAA;EACA,sBAAA;AALJ;AAQE;EAEE,qFAAA;EACA,sBAAA;AAPJ;AAUE;EAEE,+EAAA;EACA,sBAAA;AATJ;AAYE;EAEE,yFAAA;EACA,sBAAA;AAXJ;AAcE;EAEE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,8BAAA;EACA,mBAAA;AAbJ;AAgBI;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAdN;AAgBM;EACE,YAAA;EACA,WAAA;EAGA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AAhBR;AAsBI;EACE,YAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AApBN;AAsBM;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;AApBR;AAuBM;EACE,0CAAA;EACA,8BAAA;EACA,uDAAA;EACA,qFAAA;AArBR;AAwBM;EACE,yCAAA;EACA,6BAAA;EACA,sDAAA;EACA,mFAAA;AAtBR;AAyBM;EACE,0CAAA;EACA,8BAAA;EACA,uDAAA;EACA,qFAAA;AAvBR;AA0BM;EACE,uCAAA;EACA,2BAAA;EACA,oDAAA;EACA,+EAAA;AAxBR;AA2BM;EACE,4CAAA;EACA,gCAAA;EACA,yDAAA;EACA,yFAAA;AAzBR;AA4BM;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;AA1BR;AA4BQ;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AA1BV;AA6BQ;EACE,eAAA;AA3BV;AAgCQ;EACE,eAAA;EACA,gBAAA;AA9BV;AAkCM;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;AAhCR;AAkCQ;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAhCV;;AAyCA;EACE,QAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AAtCF;;AA0CE;EACE,UAAA;EACA,mBAAA;EACA,2BAAA;AAvCJ;;AA2CA;EACE,SAAA;EACA,eAAA;EACA,OAAA;EACA,gDAAA;EACA,2CAAA;EACA,YAAA;EACA,iIAAA;EACA,0BAAA;EACA,yBAAA;AAxCF;AA2CE;EACE,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAzCJ;AA2CI;EACE,cAAA;EACA,eAAA;EACA,WAAA;AAzCN;;AA6DA;EACE,iDAAA;EACA,wDAAA;AA1DF","sourcesContent":[".main-content {\n  .itemHeader {}\n\n  .acceptedBg {\n    // border: 1px solid var(--ion-color-success);\n    background: linear-gradient(13deg, var(--ion-ultra-success), var(--ion-pass-success));\n    background-color: #fff;\n  }\n\n  .rejectedBg {\n    // border: 1px solid var(--ion-color-danger);\n    background: linear-gradient(13deg, var(--ion-ultra-danger), var(--ion-pass-danger));\n    background-color: #fff;\n  }\n\n  .rescheduledBg {\n    // border: 1px solid var(--ion-color-warning);\n    background: linear-gradient(13deg, var(--ion-ultra-warning), var(--ion-pass-warning));\n    background-color: #fff;\n  }\n\n  .completedBg {\n    // border: 1px solid var(--ion-color-info);\n    background: linear-gradient(13deg, var(--ion-ultra-info), var(--ion-pass-info));\n    background-color: #fff;\n  }\n\n  .pendingBg {\n    // border: 1px solid var(--ion-color-secondary);\n    background: linear-gradient(13deg, var(--ion-ultra-secondary), var(--ion-pass-secondary));\n    background-color: #fff;\n  }\n\n  .conCard {\n\n    min-height: 25vw;\n    display: flex;\n    flex-direction: row;\n    padding: 0vw;\n    align-items: stretch;\n    justify-content: space-between;\n    border-radius: 15px;\n\n\n    .conImg {\n      height: 25vw;\n      min-width: 25vw;\n      max-width: 25vw;\n      object-fit: contain;\n      border-radius: 13px;\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      align-items: center;\n      overflow: hidden;\n      padding: 1vw;\n\n      .conPic {\n        height: 25vw;\n        width: 100%;\n        // min-width: 25vw;\n        // max-width: 25vw;/\n        object-fit: cover;\n        border-radius: 13px;\n        position: relative;\n        overflow: hidden;\n        box-shadow: var(--shadow-l);\n      }\n    }\n\n\n\n    .conInfo {\n      height: 25vw;\n      width: calc(100% - 25vw);\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      align-items: flex-start;\n      margin: 0vw;\n      position: relative;\n\n      .conStatus {\n        width: 23vw;\n        height: 6vw;\n        margin: 1vw;\n        font-size: 10px;\n        letter-spacing: 1px;\n        position: absolute;\n        top: 0;\n        right: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 25px;\n        text-transform: uppercase;\n        backdrop-filter: blur(5px);\n        box-shadow: var(--shadow-m);\n      }\n\n      .acceptedStatus {\n        border: 1px solid var(--ion-color-success);\n        color: var(--ion-text-success);\n        text-shadow: 0em 0.15em 0.05em var(--ion-color-success);\n        background: linear-gradient(13deg, var(--ion-more-success), var(--ion-clear-success));\n      }\n\n      .rejectedStatus {\n        border: 1px solid var(--ion-color-danger);\n        color: var(--ion-text-danger);\n        text-shadow: 0em 0.15em 0.05em var(--ion-color-danger);\n        background: linear-gradient(13deg, var(--ion-more-danger), var(--ion-clear-danger));\n      }\n\n      .rescheduledStatus {\n        border: 1px solid var(--ion-color-warning);\n        color: var(--ion-text-warning);\n        text-shadow: 0em 0.15em 0.05em var(--ion-color-warning);\n        background: linear-gradient(13deg, var(--ion-more-warning), var(--ion-clear-warning));\n      }\n\n      .completedStatus {\n        border: 1px solid var(--ion-color-info);\n        color: var(--ion-text-info);\n        text-shadow: 0em 0.15em 0.05em var(--ion-color-info);\n        background: linear-gradient(13deg, var(--ion-more-info), var(--ion-clear-info));\n      }\n\n      .pendingStatus {\n        border: 1px solid var(--ion-color-secondary);\n        color: var(--ion-text-secondary);\n        text-shadow: 0em 0.15em 0.05em var(--ion-color-secondary);\n        background: linear-gradient(13deg, var(--ion-more-secondary), var(--ion-clear-secondary));\n      }\n\n      .conInner {\n        height: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n        margin: 0 2vw;\n\n        .consultantName {\n          font-size: 18px;\n          letter-spacing: 1px;\n          font-weight: 600;\n        }\n\n        .consultantAbout {\n          font-size: 12px;\n        }\n\n\n\n        .conNotes {\n          font-size: 14px;\n          font-weight: 200;\n        }\n      }\n\n      .conData {\n        font-size: 14px;\n        font-weight: 400;\n        display: flex;\n        flex-direction: row;\n        min-height: 6vw;\n        margin: 1vw;\n        align-items: center;\n        width: 100%;\n        justify-content: space-evenly;\n\n        .conSlot {\n          font-size: 12px;\n          font-weight: 300;\n          font-style: italic;\n\n        }\n      }\n\n    }\n  }\n}\n\n.mainCard {\n  scale: 1;\n  border-radius: 15px;\n  box-shadow: var(--shadow-m);\n  width: 94vw;\n  height: 25vw;\n  margin: 0 auto;\n  margin-top: 4vw;\n  padding: 0vw;\n}\n\n.reorder-list-active {\n  .reorder-selected {\n    scale: 0.9;\n    border-radius: 15px;\n    box-shadow: var(--shadow-l);\n  }\n}\n\n.customFooter {\n  bottom: 0;\n  position: fixed;\n  left: 0;\n  height: calc(20vw + env(safe-area-inset-bottom));\n  padding-bottom: env(safe-area-inset-bottom);\n  width: 100vw;\n  background: linear-gradient(0deg, var(--ion-color-primary) 0%, var(--ion-more-primary) 50%, hsl(var(--drop-pass-primary)/0) 100%);\n  background-size: 200% 200%;\n  background-position: 0 0%;\n\n  // backdrop-filter: blur(20px);\n  .footerToolbar {\n    background: transparent;\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 2vw;\n\n    .footerBtn {\n      max-width: 75%;\n      min-height: 6vh;\n      height: 6vh;\n      // font-size: 14px;\n      //     font-family: var(--ion-font-family);\n      //     letter-spacing: 2px;\n      //     font-weight: 700;\n      //     color: var(--ion-text-secondary);\n      //     border-radius: 15px;\n      //     background: hsl(var(--drop-color-secondary) / 0.5);\n      //     display: flex\n      // ;\n      //     padding: 5vw;\n      //     border: 0px solid rgba(0, 0, 0, 0);\n      //     -webkit-backdrop-filter: blur(5px);\n      //     backdrop-filter: blur(5px);\n      //     box-shadow: var(--shadow-minor-anim-end), inset -0.5px 0.5px 2px hsl(var(--drop-light-secondary) / 0.5), inset 1px -1px 3px hsl(var(--drop-bright-secondary) / 0.5), inset -2px 2px 5px hsl(var(--drop-fade-secondary) / 0.75);\n      //     align-items: center;\n    }\n  }\n}\n\n.pageContainer {\n  padding-top: calc(1vh + env(safe-area-inset-top));\n  padding-bottom: calc(22vw + env(safe-area-inset-bottom));\n  // height: 500vh;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
